import { S, union } from "./combinators";
export var Toplist;
(function (Toplist) {
    Toplist[Toplist["Overall"] = 0] = "Overall";
    Toplist[Toplist["OffPiste"] = 1] = "OffPiste";
    Toplist[Toplist["BeginnerFriendly"] = 2] = "BeginnerFriendly";
    Toplist[Toplist["ChildFriendly"] = 3] = "ChildFriendly";
    Toplist[Toplist["ToughSlopes"] = 4] = "ToughSlopes";
    Toplist[Toplist["LongWindingSlopes"] = 5] = "LongWindingSlopes";
    Toplist[Toplist["Park"] = 6] = "Park";
    Toplist[Toplist["CrossCountry"] = 7] = "CrossCountry";
    Toplist[Toplist["AfterSki"] = 8] = "AfterSki";
})(Toplist || (Toplist = {}));
;
export const toplistCriteriaParser = union([
    S("offpist").map(_ => Toplist.OffPiste),
    S("nybörjarvänligt").map(_ => Toplist.BeginnerFriendly),
    S("familj").map(_ => Toplist.ChildFriendly),
    S("utmanande").map(_ => Toplist.ToughSlopes),
    S("långa").map(_ => Toplist.LongWindingSlopes),
    S("park").map(_ => Toplist.Park),
    S("längdskidor").map(_ => Toplist.CrossCountry),
    S("afterski").map(_ => Toplist.AfterSki),
    S("overall").map(_ => Toplist.Overall),
]);
export function topListCriteriaToString(s) {
    switch (s) {
        case Toplist.OffPiste: return "offpist";
        case Toplist.BeginnerFriendly: return "nybörjarvänligt";
        case Toplist.ChildFriendly: return "familj";
        case Toplist.ToughSlopes: return "utmanande";
        case Toplist.LongWindingSlopes: return "långa";
        case Toplist.Park: return "park";
        case Toplist.CrossCountry: return "längdskidor";
        case Toplist.AfterSki: return "afterski";
        case Toplist.Overall: return "overall";
    }
}
